import { useState } from "react";
import { useLang } from "@/i18n/LangContext";
import { Lang } from "@/i18n/translations";

const LOGO_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-23/prod_agent_3a0812e8-cabc-4e60-9023-9eb878dbad11/ds_logo_transparent_1343324419e041449c280c0bfa45d1f3.png";

const LANGS: Lang[] = ["de", "fr", "it", "en", "sq"];
const langFlags: Record<Lang, string> = { de: "🇩🇪", fr: "🇫🇷", it: "🇮🇹", en: "🇬🇧", sq: "🇦🇱" };
const langNames: Record<Lang, string> = { de: "DE", fr: "FR", it: "IT", en: "EN", sq: "SQ" };

interface Props {
  backHref?: string;
}

export default function SharedNavbar({ backHref = "/#/" }: Props) {
  const { lang, setLang } = useLang();
  const [langOpen, setLangOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-40 border-b border-border/60 bg-white/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
        {/* Logo */}
        <a href="/#/">
            <img src={LOGO_URL} alt="DS Logistik" className="h-14 w-auto" />
        </a>

        {/* Right: Lang switcher + back button */}
        <div className="flex items-center gap-3">
          {/* Language Switcher */}
          <div className="relative">
            <button
              onClick={() => setLangOpen(!langOpen)}
              className="flex items-center gap-1.5 rounded-full border border-border/60 bg-muted/60 px-3 py-1.5 text-xs font-bold text-foreground/80 hover:bg-muted transition-colors"
            >
              <span>{langFlags[lang]}</span>
              <span>{langNames[lang]}</span>
              <svg className={`h-3 w-3 transition-transform ${langOpen ? "rotate-180" : ""}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {langOpen && (
              <div className="absolute right-0 top-full mt-2 overflow-hidden rounded-2xl border border-border/60 bg-card shadow-xl z-50 min-w-[80px]">
                {LANGS.map((l) => (
                  <button
                    key={l}
                    onClick={() => { setLang(l); setLangOpen(false); }}
                    className={`flex w-full items-center gap-2 px-4 py-2.5 text-sm transition-colors hover:bg-muted ${lang === l ? "bg-primary/10 text-primary font-bold" : "text-foreground/80"}`}
                  >
                    <span>{langFlags[l]}</span>
                    <span>{langNames[l]}</span>
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Back button */}
          <a
            href={backHref}
            className="rounded-full border border-border/60 px-4 py-2 text-sm font-semibold hover:bg-muted transition-colors"
          >
            ← Zurück
          </a>
        </div>
      </div>
    </nav>
  );
}
